import { createAsyncThunk } from "@reduxjs/toolkit";
import { apiHandler } from "../helpers/apiHandler";

export const getAddressInformationBilling = createAsyncThunk("billing/getAddressInformationBilling", async (body: any, { getState }: { getState: any }) => {
  const { iframeJwt } = getState().helpers;
  const res = await apiHandler({
    iframeJwt,
    url: "/dialer/getAddressInformation",
    method: "post",
    body,
  });
  // console.log(res, "addressComplete3");
  return res;
});
